import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSupabaseAuth } from '../contexts/SupabaseAuthContext';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { user, userRole, loading } = useSupabaseAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole && userRole !== requiredRole && userRole !== 'admin') {
    // Redirect to appropriate dashboard based on role
    if (userRole === 'recruiter') return <Navigate to="/recruiter" replace />;
    if (userRole === 'client') return <Navigate to="/client-portal-auth" replace />;
    if (userRole === 'candidate') return <Navigate to="/candidate" replace />;

    // If no role match, go to login
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
